/* GO Motorsports section scripts: hero slideshow and product carousels. */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Hero slideshow ---------- */
  function initSlideshow(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    var slides = root.querySelectorAll('[data-slide]');
    var dots = root.querySelectorAll('[data-slide-dot]');
    var index = 0;
    var timer;
    var ms = (Number(root.dataset.speed) || 0) * 1000;
    if (slides.length < 2) return;

    function show(n) {
      index = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === index);
        s.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        var video = s.querySelector('video');
        if (video) { if (i === index) video.play().catch(function () {}); else video.pause(); }
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
        if (i === index) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }
    function start() {
      clearInterval(timer);
      if (ms > 0 && !reduceMotion) timer = setInterval(function () { show(index + 1); }, ms);
    }
    function stop() { clearInterval(timer); }

    var prev = root.querySelector('[data-slide-prev]');
    var next = root.querySelector('[data-slide-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); start(); });
    if (next) next.addEventListener('click', function () { show(index + 1); start(); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { show(i); start(); }); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    // Swipe on touch screens.
    var startX = null;
    root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) { show(index + (dx < 0 ? 1 : -1)); start(); }
      startX = null;
    });

    document.addEventListener('shopify:block:select', function (e) {
      var i = Array.prototype.indexOf.call(slides, e.target);
      if (i > -1) { show(i); stop(); }
    });
    start();
  }

  /* ---------- Product carousels ---------- */
  function initCarousel(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    var track = root.querySelector('[data-carousel-track]');
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    if (!track) return;

    function step() {
      var item = track.querySelector('.carousel__item');
      if (!item) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var perView = Math.max(1, Math.floor((track.clientWidth + gap) / (item.offsetWidth + gap)));
      return perView * (item.offsetWidth + gap);
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Product recommendations (related products) ---------- */
  function initRecommendations(root) {
    if (root.dataset.loaded) return;
    root.dataset.loaded = 'true';
    if (root.querySelector('[data-carousel-track]')) return;
    fetch(root.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (!fresh || !fresh.innerHTML.trim()) { root.hidden = true; return; }
        root.innerHTML = fresh.innerHTML;
        delete root.dataset.ready;
        initCarousel(root);
      })
      .catch(function () { root.hidden = true; });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-slideshow]').forEach(initSlideshow);
    (scope || document).querySelectorAll('[data-recommendations]').forEach(initRecommendations);
    (scope || document).querySelectorAll('[data-carousel]').forEach(function (el) {
      if (!el.querySelector('[data-carousel-track]')) return;
      initCarousel(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  // Re-run when a section is added or changed in the theme editor.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
